import ChangePassword from "views/ChangePassword";
import Dashboard from "views/Dashboard";
import InvoicePayments from "views/InvoicePayments";
import InvoiceAppointmentDetail from "views/InvoicePayments/InvoiceApptDetail";
import PermissionGroups from "views/permissions/Groups";
import PermissionSubUser from "views/permissions/SubUsers";
import UpdateGroup from "views/permissions/groups/Update";
import CreateGroup from "views/permissions/groups/Create";
import PdfView from "views/InvoicePayments/PdfView";
import AllPdfView from "views/AllInvoices/PdfView";
import InvocieList from "views/AllInvoices/AllInvoices";
import Sessions from "views/Sessions";
import LocationList from "views/Locations/Location";
import CreateLocation from "views/Locations/Create";
import UpdateLocation from "views/Locations/Update";
import Facility from "components/locations/facilities/Facility";
import Department from "components/locations/departments/Departments";
import InterpreterList from "views/Interpreters";

var routes = [
  {
    path: "",
    title: "Dashboard",
    icon: "/images/dashboard.png",
    iconActive: "/images/dashboard-fill.png",
    component: <Dashboard />,
    layout: "/",
  },
  {
    path: "locations",
    title: "Locations",
    icon: "/images/Hospital.png",
    iconActive: "/images/Hospital-fill.png",
    component: <LocationList />,
    layout: "",
  },
  {
    path: "locations/create",
    subRoute: true,
    component: <CreateLocation />,
    layout: "/admin",
  },
  {
    path: "locations/update/:id",
    subRoute: true,
    component: <UpdateLocation />,
    layout: "/admin",
  },
  {
    path: "locations/facilities/:id",
    subRoute: true,
    component: <Facility />,
    layout: "/admin",
  },
  {
    path: "locations/departments/:id",
    subRoute: true,
    component: <Department />,
    layout: "/admin",
  },
  {
    path: "sessions",
    title: "Sessions",
    icon: "/images/sessions.png",
    iconActive: "/images/sessions-fill.png",
    component: <Sessions />,
    layout: "",
  },
  {
    path: "billing",
    title: "Billing",
    icon: "/images/billing.png",
    iconActive: "/images/billing-fill.png",
    component: <InvoicePayments />,
    layout: "",
  },
  {
    path: "billing/detail/:id",
    subRoute: true,
    component: <InvoiceAppointmentDetail />,
    layout: "/admin",
  },
  {
    path: "billing/pdf-view/:id",
    subRoute: true,
    component: <PdfView />,
    layout: "/admin",
  },
  {
    path: "invoices",
    title: "Invoices",
    icon: "/images/invoices.png",
    iconActive: "/images/invoices-fill.png",
    component: <InvocieList />,
    layout: "",
  },
  {
    path: "invoices/pdf-view/:id",
    subRoute: true,
    component: <AllPdfView />,
    layout: "/admin",
  },
  {
    path: "interpreters",
    title: "Interpreters",
    icon: "/images/sub-user.png",
    iconActive: "/images/sub-user-fill.png",
    component: <InterpreterList />,
    layout: "/",
  },
  {
    path: "permissions/groups",
    title: "Groups",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <PermissionGroups />,
    layout: "/",
  },
  {
    path: "permissions/groups/create",
    subRoute: true,
    component: <CreateGroup />,
    layout: "/admin",
  },
  {
    path: "permissions/groups/update/:id",
    subRoute: true,
    component: <UpdateGroup />,
    layout: "/admin",
  },

  {
    path: "permissions/sub-users",
    title: "Sub Users",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <PermissionSubUser />,
    layout: "",
  },
  // {
  //   path: "settings/languages",
  //   subRoute: true,
  //   component: <LanguageList />,
  //   layout: "/admin",
  // },
  {
    path: "change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/",
  }
];
export default routes;
